/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const DragHandleIcon = /*#__PURE__*/ createSvgIcon(
  'DragHandleIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.756 12.5a.738.738 0 01-.537-.214.714.714 0 01-.219-.532c0-.21.072-.39.215-.535A.72.72 0 014.75 11h10.494c.212 0 .391.072.537.214.146.143.219.32.219.532 0 .21-.072.39-.215.535a.72.72 0 01-.535.219H4.756zm0-3.5a.738.738 0 01-.537-.214A.714.714 0 014 8.254c0-.21.072-.39.215-.535A.72.72 0 014.75 7.5h10.494c.212 0 .391.071.537.214.146.143.219.32.219.532 0 .21-.072.39-.215.535A.72.72 0 0115.25 9H4.756z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default DragHandleIcon;
